import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "qa-ap-progress-full" }
const _hoisted_3 = { class: "qa-ap-time" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode("x")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: "qa-audio-player",
    onKeyup: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.debounceKeyHandler && _ctx.debounceKeyHandler(...args))),
    tabindex: "0",
    ref: "playerEl"
  }, [
    (_ctx.src)
      ? (_openBlock(), _createElementBlock("audio", {
          key: 0,
          src: _ctx.src,
          ref: "audioEl"
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    _createVNode(_component_IconButton, {
      icon: _ctx.audioPlayback?.playing.value ? 'pause' : 'play_arrow',
      class: "qa-ap-play",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (
        _ctx.audioPlayback?.playing.value ? _ctx.audioPlayback?.pause() : _ctx.audioPlayback?.play()
      ), ["prevent"])),
      onKeydown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
      tabindex: "-1",
      disabled: _ctx.disabled
    }, null, 8, ["icon", "disabled"]),
    _createElementVNode("div", {
      class: "qa-ap-progress",
      onMousedown: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.down && _ctx.down(...args)), ["left","prevent"])),
      onMouseup: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.up && _ctx.up(...args)), ["prevent"])),
      onMousemove: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.drag && _ctx.drag(...args)), ["prevent"])),
      onTouchstart: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.down && _ctx.down(...args)), ["prevent"])),
      onTouchend: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.up && _ctx.up(...args)), ["prevent"])),
      onTouchmove: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.drag && _ctx.drag(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "qa-ap-progress-inner",
          style: _normalizeStyle({ width: `calc(${_ctx.percentPlayed} * 100%)` })
        }, null, 4)
      ]),
      _createElementVNode("div", {
        class: "qa-ap-progress-handle",
        style: _normalizeStyle({
          left: `calc(${_ctx.dragPercent === -1 ? _ctx.percentPlayed : _ctx.dragPercent} * 100%)`,
        }),
        tabindex: "0"
      }, null, 4)
    ], 32),
    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.secondsDisplay), 1),
    _createElementVNode("button", {
      class: "clear-btn qa-ap-rate",
      onKeyup: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"])),
      onClick: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.adjustPlaybackRate && _ctx.adjustPlaybackRate(...args)), ["prevent"])),
      disabled: _ctx.disabled
    }, [
      _createElementVNode("span", null, [
        (_ctx.rateDisplay.integer !== '0')
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass({ 'qa-ap-rate-text': _ctx.rateDisplay.decimal })
            }, _toDisplayString(_ctx.rateDisplay.integer), 3))
          : _createCommentVNode("", true),
        (_ctx.rateDisplay.decimal)
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: _normalizeClass({ 'qa-ap-rate-text': _ctx.rateDisplay.integer !== '0' })
            }, ".", 2))
          : _createCommentVNode("", true),
        (_ctx.rateDisplay.decimal)
          ? (_openBlock(), _createElementBlock("span", {
              key: 2,
              class: _normalizeClass({ 'qa-ap-rate-decimal qa-ap-rate-text': _ctx.rateDisplay.integer !== '0' })
            }, _toDisplayString(_ctx.rateDisplay.decimal), 3))
          : _createCommentVNode("", true),
        _hoisted_5
      ])
    ], 40, _hoisted_4)
  ], 544))
}